import { Row } from "@/common/custom-lists/ListView";
import { ArrowReturnRightIcon } from "@/common/icons/Solid";
import { useState } from "react";
import { connect } from "react-redux";
import { Actions as AUTH_ACTIONS } from "@/redux/actions/authenticationActions";
import { Actions as FSS_REPORT_ACTIONS } from "@/redux/actions/fssReportActions";
import Spinner from "@/common/Spinner";
import Tooltip from "@/components/common/tooltip/Tooltip";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { useEffect } from "react";

const StatusChips = ({ status }) => {
	switch (status) {
		case "Authenticated":
			return <div className="badge badge-default">{status}</div>;
		case "Signing In":
		case "Validating":
		case "Submitting":
		case "Pending":
			return (
				<div className="badge badge-default">
					{status}{" "}
					<Spinner
						style={{ marginLeft: 5, verticalAlign: "middle" }}
						className="animate-spin h-5 w-5 "
					/>
				</div>
			);
		case "Submitted":
		case "Completed":
			return <div className="badge badge-success">Completed</div>;
		case "Failed":
			return <div className="badge badge-danger">{status}</div>;
		default:
			return <div className="badge badge-warning">{status}</div>;
	}
};

const ErrorsButton = ({ onClick }) => {
	return (
		<div
			className="btn btn-danger btn-xs"
			onClick={onClick}
		>
			Errors
			<ExclamationTriangleIcon
				className="h-5 w-5"
				style={{ marginTop: 3, verticalAlign: "sub" }}
			/>
		</div>
	);
};

const FSSExpress = ({
	org,
	peNumber,
	options,
	name,
	error,
	errors,
	employeeCount,
	paymentDue,
	selected,
	status,
	onSelect,
	switchCompany,
	openErrorsModal,
}) => {
	const [checked, setChecked] = useState(false);
	const updateChecked = () => {
		setChecked(!checked);
		onSelect && onSelect(!checked, peNumber);
	};
	const completed = ["Completed", "Submitted"].includes(status);

	useEffect(() => {
		if (selected && !completed) setChecked(true);
		else setChecked(false);
	}, [selected, completed]);

	const cannotSelect = [undefined, "undefined", "No PE Number", ""].includes(peNumber);

	const totalEmployees = employeeCount
		? employeeCount
		: options?.reduce((acc, option) => acc + parseFloat(option.employeeCount) || 0, 0) || 0;

	return (
		<Row
			actionColumns={[0]}
			active={checked}
			columns={[
				<Tooltip
					content={completed ? "Submission Completed" : "Cannot Select Company with No PE Number"}
					isOpen={cannotSelect ? undefined : completed ? undefined : false}
				>
					<label className="css-input css-checkbox css-checkbox-primary">
						<input
							type="checkbox"
							checked={checked}
							disabled={cannotSelect || completed}
							onChange={(e) => {
								if (!cannotSelect) updateChecked();
							}}
						/>
						<span />
						&nbsp;
					</label>
				</Tooltip>,
				peNumber || "No PE Number",
				<a
					href="#"
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
						switchCompany(org);
					}}
				>
					{name || " "}
				</a>,
				String(totalEmployees),
				paymentDue || "0",
				<>{error ? <div className="badge badge-danger">{error}</div> : <StatusChips status={status} />}</>,
				errors ? <ErrorsButton onClick={() => openErrorsModal(errors)} /> : " ",
			]}
		>
			{options?.map((option) => {
				return (
					<Row
						subRow={true}
						active={checked}
						columns={[
							" ",
							<ArrowReturnRightIcon className="h-7 w-7" />,
							<a
								href="#"
								onClick={(e) => {
									e.stopPropagation();
									e.preventDefault();
									switchCompany(option.org);
								}}
							>
								{option.name}
							</a>,
							option.employeeCount || " ",
							option.paymentDue || " ",
							" ",
							option.errors ? <ErrorsButton onClick={() => openErrorsModal(option.errors)} /> : " ",
						]}
					/>
				);
			})}
		</Row>
	);
};

const mapStateToProps = (state, { peNumber, status: ownStatus }) => {
	const { selectedOrganisations } = state.fssExpress || {};
	const selected = selectedOrganisations?.find((org) => org.peNumber == peNumber) || {};
	const { error, status } = selected;
	return {
		error,
		selected: !!Object.keys({ ...selected }).length,
		status: status ? status : ownStatus,
	};
};

const mapDispatchToProps = (dispatch) => ({
	switchCompany: (org) => dispatch(AUTH_ACTIONS.switchCompany(org)),
	openErrorsModal: (errors) => dispatch(FSS_REPORT_ACTIONS.openFS7ValidationModal(true, errors)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FSSExpress);
